import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-financial-aid-contact',
  templateUrl: './financial-aid-contact.component.html',
  styleUrls: ['./financial-aid-contact.component.scss']
})
export class FinancialAidContactComponent implements OnInit, OnDestroy {
  financialAddListJson: any;
  financialFormListJson: any;
  financialTitleIVJson: any;
  generalData: any;
  commonServiceSubscription: Subscription;

  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService ,
    private _commonService: CommonService
  ) { }

  ngOnInit() {
    this.getFinancialAidComponentList();
  }

  getFinancialAidComponentList() {
    this.commonServiceSubscription = this._commonService.getData().subscribe(detailData => {
      if (detailData && detailData['collegeDetailGeneralData']) {
        this.financialAddListJson = detailData['collegeDetailGeneralData'].office;
        this.financialFormListJson = detailData['collegeDetailGeneralData'].forms;
        this.generalData = detailData['collegeDetailGeneralData'];
        this.financialTitleIVJson = detailData['collegeDetailGeneralData'].titleIV;
      }
    });

    const collegeID = JSON.parse(localStorage.getItem('collegeIdData'));
    const json = { collegeId: collegeID.collegeData };

    this._commonRequestResponseService.postWithHeader('college/financial/general', json)
      .subscribe(
        (financialAddListJson: any) => {
          this.financialAddListJson = financialAddListJson.office;
        },
        () => {
          this.financialAddListJson = [];
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  ngOnDestroy() {
    this.commonServiceSubscription.unsubscribe();
  }
}
